import React, { useEffect, useRef } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { getAllTagAsync, TagActions } from "../redux";
import TagTable from "./bdcDetail/bdcTable";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import { useIsAccessAllow } from "../../users/redux";

export function BdcTag() {
  const dispatch = useDispatch();
  const history = useHistory();
  const searchRef = useRef();
  const { refreshTag, searchBy, searchText } = useSelector(
    (state) => state.tag,
    shallowEqual
  );

  useEffect(() => {
    if (searchRef.current) {
      let keyPressEvent = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dispatch(TagActions.refreshTagList());
        }
      };
      let input = searchRef.current;
      input.addEventListener("keyup", keyPressEvent);

      return () => {
        input.removeEventListener("keyup", keyPressEvent);
        dispatch(TagActions.searchTextChange(""));
        input.value = "";
      };
    }
  }, [dispatch]);

  useEffect(() => {
    if (refreshTag) {
      dispatch(getAllTagAsync(searchBy, searchText));
    }
    // eslint-disable-next-line
  }, [refreshTag]);

  const onSearchTextChange = (e) => {
    dispatch(TagActions.searchTextChange(e.target.value));
  };

  const onSelectTag = (tag) => {
    history.push(`/bdc_tag/add-tag`);
  };
  const isAddTagAllow = useIsAccessAllow("bdc_tag.add_tag");
  const isSearchAllow = useIsAccessAllow("bdc_tag.list");

  return (
    <>
      <Card>
        <CardHeader title="BDC Tag">
          <CardHeaderToolbar>
            <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
              <form
                className="subheader_filter"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="form-row">
                  {isAddTagAllow && (
                    <div className="form-group mr-5 mb-1 mt-2">
                      <button
                        className="btn_new btn-sm"
                        type="button"
                        onClick={() => onSelectTag()}
                      >
                        Add
                      </button>
                    </div>
                  )}
                  {isSearchAllow && (
                    <div className="form-group mr-3 mb-1">
                      <input
                        name="Search"
                        placeholder="Search. . ."
                        type="text"
                        className="form-control"
                        value={searchText}
                        autoComplete="off"
                        onChange={onSearchTextChange}
                        ref={searchRef}
                      />
                    </div>
                  )}
                </div>
              </form>
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <TagTable />
      </Card>
    </>
  );
}
